import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Input, Button, Row, Col, Card, Modal, Form, Checkbox, message, Image } from 'antd'
import { paginationInit, formatMessageNew, dateTrans, base64Url } from '@/utils/common'
import { modalError } from '@/utils/modalUtils'
import { tagTypeSave, getTagTypeList } from '@/services/configuration/config'
import { PlusOutlined, SearchOutlined, DeleteOutlined } from '@ant-design/icons'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import UploadBtn from '@/components/Upload/Upload'
import { hasPermission } from '@/annotations/nike-react'

let fileData = null
const menu_nfc_configuration_tagType = 'menu_nfc_configuration_tagType'
const TagTypePage = () => {
  const [newModalForm] = Form.useForm()
  let formRef = useRef(null)
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [imgObj] = useState({ width: 150 * deviceSize })
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [visibleFlag, setVisibleFlag] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editItem, setEditItem] = useState({})
  const [imgUrl, setImgUrl] = useState('')

  const tableColumns = [
    {
      title: formatMessageNew('languageObj.configuration.tagTypeName'),
      dataIndex: 'type',
      render: (text, record) => {
        return (
          <div
            className={hasPermission(menu_nfc_configuration_tagType) ? 'link_name' : ''}
            onClick={() => {
              if (hasPermission(menu_nfc_configuration_tagType)) {
                tableItemClick(record)
              }
            }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.configuration.tagTypeDesc'),
      dataIndex: 'description'
    },
    {
      title: formatMessageNew('languageObj.configuration.tagTypeImage'),
      dataIndex: 'tagPicture',
      render: text => {
        return (
          <div>
            {text && (
              <Image
                rootClassName="imgReviewWrapper"
                width={imgObj.width}
                height={imgObj.width / 3.6}
                src={base64Url(text)}
              />
            )}
          </div>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.configuration.lastUpdateUser'),
      dataIndex: 'operator'
    },
    {
      title: formatMessageNew('languageObj.configuration.lastUpdateTime'),
      dataIndex: 'updateTime',
      render: text => {
        return dateTrans(text)
      }
    },
    {
      title: formatMessageNew('languageObj.configuration.default'),
      dataIndex: 'defaultMark',
      render: text => {
        return text ? 'Y' : 'N'
      }
    }
  ]

  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.configuration.tagTypeDesc',
      key: 'tagTypeDesc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]

  const tableItemClick = item => {
    setIsEdit(true)
    setEditItem(item)
    setVisibleFlag(true)
    setImgUrl(base64Url(item.tagPicture))
    newModalForm.setFieldsValue({
      defaultTagType: item.defaultMark,
      tagTypeName: item.type,
      tagTypeDesc: item.description
    })
  }

  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const searchDataFun = () => {
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    const params = {
      description: info.tagTypeDesc,
      pageNo: pagination.currentPage,
      size: pagination.pageSize,
      total: pagination.total
    }
    getTagTypeList(params).then(res => {
      const dt = res.resultData
      setTableList([])
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }

  const handleUserOk = () => {
    const values = newModalForm.getFieldsValue()
    if (
      values.tagTypeDesc?.length === 0 ||
      values.tagTypeName?.length === 0 ||
      values.tagTypeName === undefined ||
      values.tagTypeDesc === undefined ||
      !/^[a-zA-Z0-9]+$/.test(values.tagTypeName)
    )
      return
    let params = new FormData()
    params.append('defaultMark', values.defaultTagType ? true : false)
    params.append('description', values.tagTypeDesc)
    params.append('status', true)
    params.append('type', values.tagTypeName)
    if (isEdit) {
      //更新的时候要传
      params.append('id', editItem.id)
      // 修改标识
      let imgFlag = false
      if (!fileData) {
        // 没有上传图片
        if (editItem.tagPicture) {
          // 有原图
          if (!imgUrl) {
            // 图片删除了，修改了
            if (editItem.tagBoxId && editItem.tagBoxId !== '0') {
              params.append('tagBoxId ', editItem.tagBoxId)
            }
            // params.append('tagPicture', null)
            imgFlag = false
          } else {
            // 未修改图片
            // params.append('tagBoxId ', null)
            // params.append('tagPicture', null)
            imgFlag = true
          }
        } else {
          // 未修改，无图并且未上传图片
          // params.append('tagBoxId ', null)
          // params.append('tagPicture', null)
          imgFlag = true
        }
      } else {
        if (editItem.tagBoxId && editItem.tagBoxId !== '0') {
          params.append('tagBoxId ', editItem.tagBoxId)
        }
        // 上传图片
        params.append('tagPicture', fileData)
        // 有上传图片，修改了
        imgFlag = false
      }
      if (values.tagTypeDesc === editItem.description && values.defaultTagType === editItem.defaultMark && imgFlag) {
        //编辑的话，没有修改的话，不执行操作
        return
      }
    } else {
      // params.append('tagBoxId ', null)
      if (fileData) {
        // 上传图片
        params.append('tagPicture', fileData)
      } else {
        // 未上传图片
        // params.append('tagPicture', null)
      }
    }
    tagTypeSave(params)
      .then(res => {
        if (res.errorCode === '200') {
          message.success(formatMessageNew('languageObj.commonLocale.success'))
          setQueryFlag(!queryFlag)
          resetStatus()
        }
      })
      .catch(error => {
        resetStatus()
        let str = ''
        if (error.errorCode) {
          if (error.errorCode === '1308') {
            str = formatMessageNew('languageObj.configuration.descriptionRepeat')
          } else if (error.errorCode === '1301') {
            str = formatMessageNew('languageObj.configuration.tagTypeRepeat')
          } else {
            str = formatMessageNew('languageObj.httpLocale.requestError')
          }
        } else {
          str = formatMessageNew('languageObj.httpLocale.requestError')
        }
        modalError({
          content: str
        })
      })
  }
  const resetStatus = () => {
    fileData = null
    setImgUrl('')
    newModalForm.resetFields()
    setVisibleFlag(false)
    setIsEdit(false)
  }
  const handleUserCancel = () => {
    resetStatus()
  }
  const unloadBack = async formDataFile => {
    let file = formDataFile.get('file')
    fileData = file
    // 设置预览URL
    let src = await new Promise(resolve => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
    })
    setImgUrl(src)
  }
  const deleteImg = () => {
    setImgUrl('')
    fileData = null
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar ref={formRef} searchList={searchListInit}>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={8}
              xl={6}
              xxl={6}
              className="right_search"
              style={{ justifyContent: 'flex-end' }}
            >
              <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
                {formatMessageNew('languageObj.commonLocale.search')}
              </Button>
              <Button onClick={searchClearDataBtn}>{formatMessageNew('languageObj.commonLocale.clear')}</Button>
            </Col>
          </SearchBar>
        </div>
        {hasPermission(menu_nfc_configuration_tagType) && (
          <>
            <Button
              type="primary"
              style={{ marginLeft: '16px', marginTop: '10px' }}
              onClick={() => {
                setVisibleFlag(true)
              }}
            >
              <PlusOutlined />
              {formatMessageNew('languageObj.configuration.addTagType')}
            </Button>
          </>
        )}
        <div className="content-container">
          <AntdTable
            rowKey={record => record.id}
            dataSource={tableList}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="40%"
        title={
          isEdit
            ? formatMessageNew('languageObj.configuration.editTagType')
            : formatMessageNew('languageObj.configuration.addTagType')
        }
        onOk={handleUserOk}
        onCancel={handleUserCancel}
        destroyOnClose
      >
        <Form
          name="basic"
          form={newModalForm}
          labelCol={{
            span: 9
          }}
          wrapperCol={{
            span: 15
          }}
          initialValues={{}}
          autoComplete="off"
        >
          <Form.Item
            label={formatMessageNew('languageObj.configuration.defaultTagType')}
            name="defaultTagType"
            style={{ marginBottom: '10px' }}
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            label={formatMessageNew('languageObj.configuration.tagTypeName')}
            name="tagTypeName"
            style={{ marginBottom: '10px' }}
            rules={[
              {
                max: 4,
                pattern: new RegExp(/^[a-zA-Z0-9]+$/),
                message: formatMessageNew('languageObj.configuration.inputRequire')
              }
            ]}
          >
            <Input
              disabled={isEdit}
              maxLength={4}
              placeholder={formatMessageNew('languageObj.configuration.charactersNumbers')}
            />
          </Form.Item>
          <Form.Item label={formatMessageNew('languageObj.configuration.tagTypeDesc')} name="tagTypeDesc">
            <Input />
          </Form.Item>
          <Row>
            <Col span={9}></Col>
            <Col span={15}>
              <UploadBtn
                accept=".jpg"
                fileSize={50}
                fileSizeErrTip={formatMessageNew('languageObj.configuration.fileSizeErrTip') + '50KB'}
                uploadAjax={formDataFile => unloadBack(formDataFile)}
                btnName={formatMessageNew('languageObj.configuration.uploadTagImage')}
              />
              {imgUrl && (
                <div className="mt15 displayFlex alignCenter">
                  <Image
                    preview={false}
                    rootClassName="imgReviewWrapper"
                    width={imgObj.width}
                    height={imgObj.width / 3.6}
                    src={imgUrl}
                  />
                  <Button onClick={deleteImg} type="link" danger>
                    <DeleteOutlined />
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  )
}
export default TagTypePage
